export default "/profile/images/sett-7.png?d66570290da16a20ad4e8b6dd2e4595f";